import PokemonHome from "../components/PokemonHome";

const Home = () => {
  return <PokemonHome />;
};

export default Home;
